var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5 0L7.64563 1.14562L3.11187 5.6875H13V7.3125H3.11187L7.64563 11.8544L6.5 13L0 6.5L6.5 0Z"}));
}

ArrowLeft.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"currentColor"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
